import images from "../../ImageVariables";
import "../SCSS/styles.css";
function DeactivatePage() {
  return (
    <div className="deactivate-page">
      <div className="company-logo-cover"></div>
      <div className="message-image-cover">
        <div className="image-cover">
          <img height={"80%"} src={images.ErrorSign} alt="error-sign"></img>
        </div>
        <div className="text-cover">
          <p className="text-line-1">
            This survey you're looking for is no longer available
          </p>
          <p className="text-line-2">Please contact the survey owner.</p>
        </div>
      </div>
    </div>
  );
}
export default DeactivatePage;
